// extracted by mini-css-extract-plugin
module.exports = {"ldsOuroboroRotate":"style-module--lds-ouroboro-rotate--tViuj"};